import { NextApiClient } from "@3cad/nextcore";

class CustomerExtendedApiClient {
    static service = "misuraemme";
    //TODO: get it from vue store or form NextAPiCLient
    //static backsite = NextApiClient.backSite; //returns null...
    //static backsite = store.getters.["getPreferences"].backsite; //returns undefined...
    //for now read from local storage
    static backsite = () => {
        let backsite = JSON.parse(localStorage.getItem("3cad.config")).backsite;
        return backsite;
    };

    /**
     * sets multiple climits from XLSX file
     * @param catalog (:string) current catalog
     * @param file (:File) XLSX file containig climits data to be imported
     * @param replaceData (:boolean) true value delete + insert, false value only insert
     */
    static importClimitsDataFromXLSX(
        catalog,
        file,
        replaceData,
        cb = j => {
            console.log(j);
        },
        cbErr = j => {
            console.error(j);
        }
    ) {
        //prepare form data
        const formData = new FormData();
        formData.append("_UID", NextApiClient.getUID());
        formData.append("Catalogo", catalog);
        formData.append("replaceData", "" + replaceData);
        formData.append(file.name, file);

        let endpoint = `${CustomerExtendedApiClient.backsite()}/${CustomerExtendedApiClient.service}.asmx/jImportFileClimitsGroup`;
        let xhr = new XMLHttpRequest();

        xhr.open("POST", endpoint, true);
        xhr.onload = () => {
            //parse xml response
            let responseJSON = NextApiClient.parseResponse(xhr.response);
            let res = responseJSON;
            if (xhr.status === 200) {
                if (cb) cb(res);
            } else {
                try {
                    if (cbErr) cbErr(res);
                } catch (err) {
                    if (cbErr) cbErr(xhr.response);
                }
            }
        };
        xhr.send(formData);
    }

    /**
     * gets all existing climits of a catalog into a XLSX file
     * @param catalog (:string) current catalog
     * @returns DataURL base64 encoded string of the XLSX file
     */
    static exportClimitsDataFromXLSX(
        catalog,
        cb = j => {
            console.log(j);
        },
        cbErr = j => {
            console.error(j);
        }
    ) {
        let params = {
            Catalogo: catalog
        };
        NextApiClient.com(
            CustomerExtendedApiClient.service,
            "jExportFileClimitsGroup",
            params,
            json => {
                if (cb) cb(json);
            },
            err => {
                if (cbErr) cbErr(err);
            }
        );
    }
}

export { CustomerExtendedApiClient };



// WEBPACK FOOTER //
// ./src/custom/giorgetti/classes/CustomerExtendedApiClient.js